import React, { useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import FontComponant from "../../../design/FontComponant";
import CustomeFontChildSection from "./CustomeFontChildSection";

let previousPanel = "custom-text"; // Default fallback

export const CustomFontPanel = (store) => {
  previousPanel = store.previousOpenedSidePanel || "custom-text";
  if (store.selectedElements[0]) {
    console.log('store.openSidePanel call 1')
    store.openSidePanel("custom-fonts");
  } else {
    console.log('store.openSidePanel call 2')
    store.openSidePanel(previousPanel);
  }
};

const CustomFontSection = {
  name: "custom-fonts",
  Tab: () => "",

  Panel: observer(({ store }) => {
    const previousPanelRef = React.useRef(
      store.previousOpenedSidePanel || "custom-text"
    );
  
    React.useEffect(() => {
      if (store.selectedElements.length > 0) {
        console.log("store.openSidePanel call 1");
        store.openSidePanel("custom-fonts");
      } else {
        console.log("store.openSidePanel call 2");
        store.openSidePanel(previousPanelRef.current);
      }
    }, [store, store.selectedElements.length]);
  
    return (
      <div style={{ padding: 10 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Fonts</h3>
  
          <button
            onClick={() =>
              store.openSidePanel('')
              
            }
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              display: "flex",
              alignItems: "start",
            }}
          >
            <img
              src={"/assets/images/close-icn.svg"}
              className="nextarrow"
              alt=""
              style={{ width: "1.563vw" }}
            />
          </button>
        </div>
        {store.selectedElements[0] ? (
          <CustomeFontChildSection store={store} />
        ) : (
          <p>Please select a text box</p>
        )}
      </div>
    );
  })
  
};

export default CustomFontSection;
